export default "__VITE_ASSET__jxTFztnY__"